<div class="row" [ngClass]="tableOptions.changeOrderModalLabel ? 'justify-content-between' : 'justify-content-end'">
  <div class="col-auto text-left py-1" *ngIf="tableOptions.changeOrderModalLabel">
    <jhi-bary-button [label]="'BTN.DISPLAY_ORDER' | translate" icon="list-ol" [outline]="true" (clickEvent)="openChangeOrderModal()"></jhi-bary-button>
  </div>
  <div class="col-auto">
    <div class="row">
      <div class="col-auto text-right py-1" *ngIf="tableOptions.redirectButtonLabel && tableOptions.redirectButtonLink">
        <jhi-bary-button [label]="tableOptions.redirectButtonLabel | translate" [outline]="true" icon="file" [routerLink]="tableOptions.redirectButtonLink"></jhi-bary-button>
      </div>
      <div class="col-auto text-right py-1" *ngIf="tableOptions.createModalLabel || tableOptions.createAndRedirectModalLabel">
        <ng-container *ngIf="tableOptions.createButtonLabel; else SimpleAddBtn">
          <jhi-bary-button [label]="tableOptions.createButtonLabel | translate" icon="plus" (clickEvent)="openAddNew(false)"></jhi-bary-button>
        </ng-container>
        <ng-template #SimpleAddBtn>
          <jhi-bary-button [label]="'BTN.NEW' | translate" [outline]="true" icon="plus" (clickEvent)="openAddNew(false)"></jhi-bary-button>
        </ng-template>
      </div>
    </div>
  </div>
</div>
